import initCTAButtons from '../property/cta-buttons';
import initCTACheckboxes from '../property/cta-checkboxes';
import ReadMore from '../property/read-more';
import autoLoad from '../ajax/lazy-load-content';
import initPropertyDescriptionHandlers from '../property/descriptions';
import { getExtendedInactivityTimeout } from '../alert-popups/inactivity-controller';
import { parseEscapedJSONString } from '../json/parse';
import initPropertyErrorReport from '../property/error-report';
import initPropertyMediaHandler from '../property/media';
import Logger from '../logging/logger';
import { yieldToMainThread } from '../yield';
import requestIdleCallback from '../shims/requestIdleCallback';
import { pushEcommerceEvent } from '../analytics/ga/ecommerce';
import initPropertyEnquiryForms from '../property/enquiry';

async function onPopupOpenProperty( event: CustomEvent ) {
    const detail = event.detail || {};

    Logger.info( 'Event Triggered: onPopupOpenProperty', detail );

    const container: HTMLElement | Document = detail.container || document;

    initPropertyEnquiryForms( container );

    initPropertyMediaHandler( container );

    initPropertyDescriptionHandlers( container );

    initCTAButtons( container );

    const popupSidebar = document.querySelector<HTMLElement>( '.pagepopup__sidebar' );

    if ( popupSidebar ) {
        requestIdleCallback( () => {
            initCTACheckboxes( container );
        } );
    }

    const propertyErrorReportBtn = container.querySelector<HTMLButtonElement>( '.twc__property-error-report' );

    if ( propertyErrorReportBtn ) {
        initPropertyErrorReport( propertyErrorReportBtn );
    }

    const propertyDescription = container.querySelector<HTMLElement>( '[data-desc-lang] > p.property-description' );

    if ( propertyDescription ) {
        new ReadMore( propertyDescription, {
            readMoreText: propertyDescription.dataset.tsReadMore,
            textLimit: 600,
        } );
    }

    if ( detail.originalEvent && detail.originalEvent.target && detail.originalEvent.target.closest( '[data-ecommerce-event]' ) ) {
        pushEcommerceEvent( parseEscapedJSONString( detail.originalEvent.target.closest( '[data-ecommerce-event]' ).dataset.ecommerceEvent ) );
    }

    // Initialise Map
    document.dispatchEvent( new CustomEvent( 'twc:init-map', {
        bubbles: true,
        detail: {
            container: container,
        },
    } ) );

    await yieldToMainThread();

    // Load related properties
    autoLoad( container );

    document.dispatchEvent( new CustomEvent( 'twc:alertable:timeout-change', {
        bubbles: true,
        detail: {
            timeout: getExtendedInactivityTimeout(),
        },
    } ) );
}

export default onPopupOpenProperty;
